/**
 * <s-header-search> — turns the inline header search bar into a trigger for the
 * live predictive-search panel. Typing (or focusing with text) opens the panel,
 * carries the typed characters across, and lets the panel's live form fetch
 * results as you type. Pressing Enter without JavaScript still submits natively.
 */
class HeaderSearch extends HTMLElement {
  #input;

  connectedCallback() {
    this.#input = this.querySelector('input[type="search"]');
    if (!this.#input) return;

    this.#input.addEventListener('input', () => this.#open());
    this.#input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.#open();
      }
    });
    // Focus alone never opens the panel: closing the dialog returns focus here,
    // and reopening on focus would make the panel impossible to close.
    const dialog = document.getElementById('predictive-search');
    const panelInput = document.getElementById('predictive-search-input');
    if (dialog && panelInput) {
      // Keep the header bar in sync with what was typed in the panel.
      dialog.addEventListener('close', () => { this.#input.value = panelInput.value; });
    }
  }

  #open() {
    const dialog = document.getElementById('predictive-search');
    const target = document.getElementById('predictive-search-input');
    if (!dialog || !target) return;

    const value = this.#input.value;
    if (!dialog.open) {
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.hidden = true;
      trigger.setAttribute('commandfor', 'predictive-search');
      trigger.setAttribute('command', 'show-modal');
      this.appendChild(trigger);
      trigger.click();
      trigger.remove();
      if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
    }

    target.value = value;
    target.focus();
    const end = value.length;
    try { target.setSelectionRange(end, end); } catch (_) { /* search inputs in some browsers */ }
    target.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

if (!customElements.get('s-header-search')) customElements.define('s-header-search', HeaderSearch);
